import gsap from 'gsap'

interface SetupLandingAnimationTargets {
  heading: HTMLElement | null
  subtitle: HTMLElement | null
  cta: HTMLElement | null
  card: HTMLElement | null
}

export const animateSetupLandingIn = ({
  heading,
  subtitle,
  cta,
  card,
}: SetupLandingAnimationTargets): gsap.core.Timeline | undefined => {
  const introTargets = [heading, subtitle, cta, card].filter(
    (target): target is HTMLElement => Boolean(target)
  )
  if (!introTargets.length) return undefined

  const timeline = gsap.timeline()

  timeline.from(introTargets, {
    opacity: 0,
    y: 16,
    duration: 0.5,
    stagger: 0.15,
    ease: 'power2.out',
  })

  const listItems = card?.querySelectorAll('li')
  if (listItems?.length) {
    timeline.from(
      listItems,
      {
        opacity: 0,
        y: 12,
        duration: 0.4,
        stagger: 0.15,
        ease: 'power2.out',
      },
      '-=0.2'
    )
  }

  return timeline
}
